import {atom} from "recoil";
import {SelectElementModelFE} from "../api/types/generic";

export type FormSearchAcrissOrderModel = {
    legalEntities: SelectElementModelFE[] | SelectElementModelFE | string | string[] | null
}

export type AcrissOrderResponse = {
    id: number,
    acriss: string,
    classification: number,
    description: string,
    legalEntity: string
}

export const initialAcrissOrderFilters: FormSearchAcrissOrderModel = {
    legalEntities: null
};
export const acrissOrderFiltersAtom = atom<FormSearchAcrissOrderModel>({
    key: "acrissOrderFiltersAtom",
    default: initialAcrissOrderFilters
});